module.exports = __webpack_public_path__ + "img/callImg.27a05a76.png";